import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

/**
 * Table view tab icon — a rounded container divided by three horizontal
 * dividers and a vertical divider, representing the spreadsheet-style Table
 * view.
 */
@Component({
  selector: 'lib-view-tab-table-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      [style.color]="color()"
      [class]="iconClass()"
      stroke="currentColor"
      stroke-width="1.5">
      <path
        d="M3.24335 16.758C2.08398 15.5986 2.08398 13.7326 2.08398 10.0007C2.08398 6.2687 2.08398 4.40273 3.24335 3.24335C4.40273 2.08398 6.2687 2.08398 10.0007 2.08398C13.7326 2.08398 15.5986 2.08398 16.758 3.24335C17.9173 4.40273 17.9173 6.2687 17.9173 10.0007C17.9173 13.7326 17.9173 15.5986 16.758 16.758C15.5986 17.9173 13.7326 17.9173 10.0007 17.9173C6.2687 17.9173 4.40273 17.9173 3.24335 16.758Z"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path d="M2.08398 7.5H17.9173" />
      <path d="M2.08398 10.834H17.9173" />
      <path d="M2.08398 14.166H17.9173" />
      <path d="M10 17.9167V7.5" stroke-linecap="round" />
    </svg>
  `,
})
export class ViewTabTableIconComponent extends BaseIconComponent {
  override width = input<string>('24');
  override height = input<string>('24');
  override viewBox = input<string>('0 0 20 20');
}
